export default __webpack_public_path__ + "static/hero-l5-bg-course2-e10629f8b1c18f4130db0e89eb559ea5.png";